import { render, staticRenderFns } from "./SendIndividuallyTable.vue?vue&type=template&id=0aa1e27a"
import script from "./SendIndividuallyTable.vue?vue&type=script&lang=js"
export * from "./SendIndividuallyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports